import {initTemplateSubstitutions} from './templateSubstitutions';

export const additionalCostSubstitutions =  initTemplateSubstitutions({
  name: {},
  percentage: {fn: (value) => Math.abs(value)},
  vendor: {field: 'vendorName'},
});
